const envBool = (value, fallback = true) => {
  if (typeof value === 'boolean') return value;
  if (value === undefined || value === null || value === '') return fallback;

  const normalized = String(value).trim().toLowerCase();
  if (['true', '1', 'yes', 'on'].includes(normalized)) return true;
  if (['false', '0', 'no', 'off'].includes(normalized)) return false;
  return fallback;
};


export const authMethods = {
  emailEnabled: envBool(process.env.REACT_APP_AUTH_ENABLE_EMAIL, true),
  googleEnabled: envBool(process.env.REACT_APP_AUTH_ENABLE_GOOGLE, true),
  phoneEnabled: envBool(process.env.REACT_APP_AUTH_ENABLE_PHONE, true),
};
